import { SVG } from '../SVG'

const TextDocIcon = ({ style = {}, stroke = 'var(--primary-color)', ...props }) => (
  <SVG width='55' height='55' viewBox='0 0 55 55' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
    <rect width='55' height='55' fill='white' />
    <g clipPath='url(#clip0_4167_22162)'>
      <path d='M47.0376 6.94922H8.9624V48.0517H47.0376V6.94922Z' stroke={stroke} strokeWidth='2' strokeMiterlimit='10' fill='white' />
      <path d='M15 15L41 15' stroke={stroke} strokeWidth='2' strokeMiterlimit='10' fill='white' />
      <path d='M15 20H25.5541' stroke={stroke} strokeWidth='2' strokeMiterlimit='10' fill='white' />
      <path d='M15 30H33' stroke={stroke} strokeWidth='2' strokeMiterlimit='10' fill='white' />
      <path d='M15 25H37' stroke={stroke} strokeWidth='2' strokeMiterlimit='10' fill='white' />
    </g>
    <defs>
      <clipPath id='clip0_4167_22162'>
        <rect width='40' height='43' fill='white' transform='translate(8 6)' />
      </clipPath>
    </defs>
  </SVG>
)

export default TextDocIcon
